import React from "react";
import { cn } from "@/lib/utils";
import PlaceholderImage from "@/assets/images/stories/resources-text-card/placeholder-image.jpeg";
import TextCardImageLeft, {
  TextCardImageLeftProps,
} from "@/components/ui/text-card-image-left";

export const OFFICE_LOCATIONS_DATA = [
  {
    image: {
      src: PlaceholderImage.src,
      alt: "",
    },
    title: "Title 1",
    description: "Text 1",
    button: {
      children: "Learn More",
      href: "#",
    },
  },
  {
    image: {
      src: PlaceholderImage.src,
      alt: "",
    },
    title: "Title 2",
    description: "Text 2",
    button: {
      children: "Learn More",
      href: "#",
    },
  },
  {
    image: {
      src: PlaceholderImage.src,
      alt: "",
    },
    title: "Title 2",
    description: "Text 2",
    button: {
      children: "Learn More",
      href: "#",
    },
  },
];

export interface OfficeLocationsProps {
  id?: string;
  className?: string;
  heading?: string;
  items: TextCardImageLeftProps[];
}

const OfficeLocations: React.FC<OfficeLocationsProps> = ({
  id = "office-locations",
  className,
  heading = "Heading",
  items = OFFICE_LOCATIONS_DATA,
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn(
        "mx-auto flex w-full max-w-lg flex-col gap-4 p-4 md:gap-6 md:px-6 md:py-8 lg:gap-8 lg:px-3 lg:py-10",
        className
      )}
    >
      <div className="flex flex-col gap-2 font-montserrat lg:gap-4">
        <h2 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
          {heading}
        </h2>
      </div>
      <div className="flex flex-col gap-4 md:flex-row lg:gap-12">
        {items.map((item) => (
          <TextCardImageLeft
            key={id + "-" + item.title}
            image={{
              src: item.image.src,
              alt: item.image.alt,
            }}
            title={item.title}
            description={item.description}
            button={{
              children: item.button.children,
              href: item.button.href,
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default OfficeLocations;
